export default styles => {
  styles.addLotPriceMarker(
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 128.8">
      <defs>
        <filter id="shadow" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha"/>
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood flood-opacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <title>lot marker</title>
      <path filter="url(#shadow)" class="lot-marker__price" d="M14,81.8H89a5,5,0,0,1,5,5v25a5,5,0,0,1-5,5H14a5,5,0,0,1-5-5v-25A5,5,0,0,1,14,81.8Z"/>
      <path filter="url(#shadow)" class="lot-marker__pin" d="M54.69,6A28.42,28.42,0,0,0,26.24,34.38s0,0,0,.06c0,18.35,23.68,51.25,28.45,51.25S83.13,52.88,83.13,34.44A28.47,28.47,0,0,0,54.69,6Zm0,44.42A16.13,16.13,0,1,1,70.74,34.21q0,.08,0,.15A16.14,16.14,0,0,1,54.69,50.41Z"/>
      <circle x="0" y="0" r="16" fill="rgba(255, 255, 255, 0.1)" transform="translate(55 36)"></circle>
      <text class="fc-lot-price-display" x="52" y="107"></text>
    </svg>
  `,
    'fc-lot-price-display'
  );

  styles.addPackageMarker(
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 128.8">
      <defs>
        <filter id="shadow" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha"/>
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood flood-opacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <title>package marker</title>
      <path filter="url(#shadow)" class="package-marker__price" d="M14,81.8H89a5,5,0,0,1,5,5v25a5,5,0,0,1-5,5H14a5,5,0,0,1-5-5v-25A5,5,0,0,1,14,81.8Z"/>
      <path filter="url(#shadow)" class="package-marker__pin" d="M54.69,6A28.42,28.42,0,0,0,26.24,34.38s0,0,0,.06c0,18.35,23.68,51.25,28.45,51.25S83.13,52.88,83.13,34.44A28.47,28.47,0,0,0,54.69,6Zm0,44.42A16.13,16.13,0,1,1,70.74,34.21q0,.08,0,.15A16.14,16.14,0,0,1,54.69,50.41Z"/>
      <circle x="0" y="0" r="16" fill="rgba(255, 255, 255, 0.1)" transform="translate(55 36)"></circle>
      <text class="fc-package-price-display" x="52" y="107"></text>
    </svg>
  `,
    'fc-package-price-display'
  );

  styles.addEstateMarker(
    `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103 128.8">
      <defs>
        <filter id="shadow" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha"/>
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood flood-opacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <title>estate marker</title>
      <path filter="url(#shadow)" class="estate-marker__pin" d="M54.69,6A28.42,28.42,0,0,0,26.24,34.38s0,0,0,.06c0,18.35,23.68,51.25,28.45,51.25S83.13,52.88,83.13,34.44A28.47,28.47,0,0,0,54.69,6Zm0,44.42A16.13,16.13,0,1,1,70.74,34.21q0,.08,0,.15A16.14,16.14,0,0,1,54.69,50.41Z"/>
      <text className="fc-package-price-display" x="52" y="107"/>
    </svg>
    <div class="estate-marker__name"/>
  `
  );

  styles.addGlobalClusterOptions({
    gridSize: 20,
    maxZoom: 19
  });

  styles.addFilterLotCluster({
    url: '/images/lot-cluster.png',
    height: 44,
    width: 44,
    textSize: 14,
    textColor: 'white'
  });

  styles.addEstateCluster({
    url: '/images/lot-cluster.png',
    height: 44,
    width: 44,
    textSize: 14,
    textColor: 'white'
  });

  styles.addPackageOutline('#068450', 3);
  styles.addStageOutline('#5e2020', 3);
  // styles.addLotOutline('#5e2020', 3);
};
